import { createContext } from 'react';
import { IProfileProjectContext } from '../interfaces/profile-project.interface';

export const ProfileProjectContext = createContext({} as IProfileProjectContext);
